import { useEffect } from "react";
import { useIntercom } from "react-use-intercom";

// The launcher floats above every z-index we can reach, right where the focus view's footer actions sit.
export const useHiddenIntercomLauncher = (): void => {
  const { update } = useIntercom();
  useEffect(() => {
    update({ hideDefaultLauncher: true });
    return () => update({ hideDefaultLauncher: false });
  }, [update]);
};
